<script setup>
import { defineProps, onMounted, ref } from 'vue';
import { postResentOTP } from '@/apis/OTP';

const props = defineProps({
    isImmediate: Boolean,
    timeVal: { // 分鐘倒數
        type: Number,
        default: 5,
    },
    reSendTimeVal: {
        type: Number,
        default: 1,
    },
    beginCounting: Function,
    stopCounting: Function,
    buttonText: {
        type: String,
        default: '重新發送',
    },
    buttonDisabled: Boolean,
    inputValue: String,
    setInputValue: Function,
    inputSize: Number,
    inputdisabled: Boolean,
    setData: Function,
    reSendLimit: Function,
    title: {
        type: String,
        default: '輸入動態密碼'
    },
    titleClass: {
        type: String,
        default: 'text-xl'
    }
});

const timeVisible = ref(false);
const sendTimes = ref(0);
const disableResendInternal = ref(false);
let timer;
let entryTime = 0;  //頁面載入十的時間
let currentTime = 0; //紀錄計時器內的時間
let initValue = 0;

let timeVal = props.timeVal; //分鐘倒數
let maxtime = timeVal * 60; // 換算秒
const msg = ref(timeVal + ':00');
const reSendTimeVal = props.reSendTimeVal; //分鐘倒數
let reSendTimer;
const reSendMaxtime = reSendTimeVal * 60; // 換算秒



const countDown = () => {
    currentTime = parseInt(new Date().getTime() / 1000); //紀錄計時器內的時間
    let timeDifference = (currentTime - entryTime);
    let mytime = maxtime - timeDifference;
    if (timeDifference <= maxtime) {
        let minutes = Math.floor(mytime / 60);
        let seconds = Math.floor(mytime % 60);
        msg.value = minutes + ':' + ((seconds < 10) ? '0' + seconds : seconds);
    } else {
        clearInterval(timer);
        // isCounting.value = false;
        if (props.stopCounting) {
            props.stopCounting();
        }
    }
};

const reSendCountDown = () => {
    const timeDifference = (currentTime - entryTime);
    // let mytime = reSendMaxtime - timeDifference;
    if (timeDifference <= reSendMaxtime) {
        // let minutes = Math.floor(mytime / 60);
        // let seconds = Math.floor(mytime % 60);
    } else {
        clearInterval(reSendTimer);
        if (props.stopCounting) {
            props.stopCounting();
        }
    }
};
// 歸零重新計算
const resetCountTime = () => {
    entryTime = parseInt(new Date().getTime() / 1000);// 頁面載入十的時間
    currentTime = 0; // 紀錄計時器內的時間
    timer = setInterval(countDown, 1000);
    reSendTimer = setInterval(reSendCountDown, 1000);
};

const requestVerifyCode = () => {

    if (initValue > 0) {
        resendOtp();
    }
    initValue = initValue + 1;

    if (props.beginCounting) {
        props.beginCounting();
    }

    //歸零重新計算
    resetCountTime();

    if (!timeVisible.value) {
        timeVisible.value = true;
    }



};

onMounted(() => {

    if (props.isImmediate) {
        requestVerifyCode();
    }

});


const resendOtp = () => {
    // isLoading.value = true;
    // errorMsg.value = '';
    // otpCode.value = '';
    // console.log(sendTimes.value);
    postResentOTP().then(res => {
        //verifyErrorTimes.value = 0;
        sendTimes.value = res.data.resendTimes;
        //props.reSendCount = sendTimes.value;
        props.setData(res?.data?.otpCodePre);
        props.reSendLimit(sendTimes.value);
        if (sendTimes.value >= 3) {
            disableResendInternal.value = true;
        }
    }).catch(err => {
        sendTimes.value = err.data?.resendTimes;
        props.setData(err?.data?.otpCodePre);
        props.reSendLimit(sendTimes.value);
        if (sendTimes.value >= 3) {
            disableResendInternal.value = true;
        }
    }).finally(() => {

    });
    setTimeout(() => {
        // isCounting.value = true;
        // isLoading.value = false;
    }, 3000);
};

</script>

<template>

    <div>
        <div class="flex justify-between items-center pb-2">
            <h3 class="font-bold" :class="titleClass">{{ title }}</h3>
            <div>
                <button class="text-[#0093C1] font-bold disabled:text-[#86878F]"
                    :disabled="buttonDisabled || disableResendInternal" @click="requestVerifyCode">{{
                        (timeVisible) ? buttonText :
                            '發送動態密碼'
                    }}
                </button>
            </div>
        </div>
        <slot v-if="$slots.default">
        </slot>
        <input type="text" :placeholder="'請輸入 ' + inputSize + ' 碼動態密碼'" :maxlength="inputSize" :size="inputSize"
            :disabled="inputdisabled" :value="inputValue" @input="(e) => { setInputValue(e.target.value) }" v-else />

        <p class="pt-2" v-show="timeVisible"> 動態密碼將在 <span class="text-[#EB4751]"> {{ msg }} </span> 分鐘後失效
        </p>

    </div>

</template>

<style scoped></style>
